import styled, { css, keyframes } from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
} from '@telialt/common-theme/src/purpurSelectors';

const bounce = keyframes`
    from {
        transform: scale(1);
    }

    50% {
        transform: scale(1.05);
    }

    to {
        transform: scale(1);
    }
`;

export const SalonInfoWrapper = styled.div<{ $isAnimated?: boolean }>`
    order: 2;
    display: flex;
    border: 1px solid #ccc;
    border-radius: 0.5rem;
    padding: ${getPurpurSpacing('300')};
    margin-top: ${getPurpurSpacing('300')};
    margin-bottom: ${getPurpurSpacing('300')};

    ${({ $isAnimated }) =>
        $isAnimated &&
        css`
            animation: ${bounce} 0.5s;
        `};
`;

export const SalonInfoContainer = styled.div`
    width: 100%;
`;

export const SalonTitle = styled.div`
    font-weight: ${getPurpurTypography('weightBold')};
`;

export const SalonAlert = styled.div`
    background: ${getPurpurColor('orange500')};
    color: ${getPurpurColor('functionalWhite')};
    padding: 0.625rem;
    font-size: 0.875rem;
    border-radius: 0.25rem;
    margin-top: ${getPurpurSpacing('300')};
`;

export const WorkTimesList = styled.div`
    margin: ${getPurpurSpacing('300')} 0;
`;

export const WorkTimeItemContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${getPurpurSpacing('100')};
    font-size: 0.875rem;
    line-height: 1;
    margin-top: ${getPurpurSpacing('300')};
`;

export const WorkTimeLunch = styled.div`
    display: flex;
    align-items: center;
    margin-left: ${getPurpurSpacing('100')};
    gap: ${getPurpurSpacing('100')};
    color: ${getPurpurColor('textMedium')};
`;

export const WorkTimeDayLabel = styled.div`
    width: 1.375rem;
`;

export const AttributesContainer = styled.div`
    border-top: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderWeak')};
    padding: ${getPurpurSpacing('200')} 0;
`;

export const AttributeRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${getPurpurSpacing('200')};
`;
